module.exports = __webpack_public_path__ + "img/dashboard-guests.6a0006ae.png";